import { Card } from "react-bootstrap";
import parse from 'html-react-parser';
import log from "loglevel";

const TopInfoBox = ({ otherActivityDetails, otherActivityData, activity_evaluated }) => {

    let total_marks = 0;
    const seenQuestions3 = new Set();

    const getTotalMarks = () => {
        var student_marks = 0;
        {
            otherActivityData?.question_set?.filter(activity => {
                const isDuplicate = seenQuestions3.has(activity.question_id);
                seenQuestions3.add(activity.question_id);
                return !isDuplicate;
            }).map((activity, index) => {
                if (activity?.marks) {
                    total_marks = total_marks + activity?.marks;
                    student_marks = student_marks + activity?.questionresponse_set?.scored_marks;
                    log.log("total_marks ", total_marks, activity?.marks)
                }
            })
        }
        log.log("total_marks", total_marks);
        if (activity_evaluated) {
            return `${student_marks} / ${total_marks}`
        }
        return total_marks;
    }

    return (
        <Card className="text-center" style={{
            // marginTop: "20px",
            // padding: "10px",
            border: "1px solid #ddd"
        }}>
            {/* <Card.Header style={{ backgroundColor: "#f7f7f7" }}></Card.Header> */}
            <Card.Body style={{ backgroundColor: "#f0f3f8" }}>
                {otherActivityDetails?.lab_data?.title ?
                    <Card.Title style={{ fontSize: "1.5rem", fontWeight: "bold", marginBottom: "10px" }}>
                        {otherActivityDetails.lab_data?.title}
                    </Card.Title> : <></>
                }
                <Card.Text style={{ fontSize: "1rem", marginBottom: "20px" }}>
                    <span style={{ fontWeight: "bold", fontSize: 40, color: 'rgb(41, 121, 255)' }}>{otherActivityData?.name}</span><br />
                    <span style={{ fontWeight: "bold", fonSize: 8, color: 'black' }}>Total Marks: {getTotalMarks()}</span>
                </Card.Text>
                <div style={{ textAlign: "left", marginTop: "10px", fontWeight: "bold", fontSize: 14 }}>
                    {otherActivityData?.description && typeof otherActivityData.description === 'string' ? parse(otherActivityData.description) : null}
                </div>
            </Card.Body>
        </Card>
    )
}

export default TopInfoBox;